class AlertService {

  constructor($rootScope, $q) {
    var self = this;
    self.$rootScope = $rootScope;
    self.$q = $q;
    self.counter = 0;
  }

  error(message) {
    var self = this;

    var alert = {
      id: self.counter++,
      type : 'error',
      message: message
    };

    var defer;
    defer = self.$q.defer();
    defer.reject('error');
    self.$rootScope.$broadcast('alert', alert);
    return defer.promise;

    // return new Promise(
    //     function(resolve, reject){
    //       self.$rootScope.$broadcast('alert', alert);
    //         resolve('error');
    //     }
    // );
  }

  warning(message) {
    var self = this;

    var alert = {
      id: self.counter++,
      type: 'warning',
      message: message
    };

    return new Promise(
        function (resolve, reject) {
          self.$rootScope.$broadcast('alert', alert);
          resolve('warning');
        }
    );
  }

  success(message) {
    var self = this;

    var alert = {
      id: self.counter++,
      type : 'success',
      message: message
    };

    return new Promise(
        function(resolve, reject){
          self.$rootScope.$broadcast('alert', alert);
          resolve('success');
        }
    );
  }

}
AlertService.$inject = ['$rootScope', '$q'];
export default AlertService;
